<div class="pcf-container vg-paragraph-one" *ngIf='!pcfAccepted'>
    <p [innerHTML]="portfolioAuthorizedDisclaimer?.contentValue"></p>
        <p>Portfolio composition as of {{ asOfDate | ESTPipe }}</p>
    <p><a href="javascript:void(0)" class="link pcf-link" tabindex="0" role="button" (click)="pcfDialog.openModalDialog()">
        View the PCF for this Vanguard ETF</a></p>
</div>

<c11n-modal-dialog modalId="pcfContainerModal" [headingText]="'Terms and conditions of use of the PCF'" primaryButtonLabel="Accept" secondaryButtonLabel="Do not accept" (primaryClick)="userAccepted(true);" (secondaryClick)="userAccepted(false);" #pcfDialog>
    <div c11n-modal-dialog-body>
        <p  [innerHTML]="portfolioCompositionFileDisclaimer?.contentValue"></p>
    </div>
</c11n-modal-dialog>